export default __webpack_public_path__ + "static/media/Spotify2.c9048565.png";